import * as types from "../types";

export const featureSettingsRequest = ({reqKey}) => ({
    type: types.FETCH_FEATURE_SETTING_REQUEST,
    payload:{
        reqKey
    }
});

export const featureSettingsSuccess = ({resFeature}) => ({
    type: types.FETCH_FEATURE_SETTING_SUCCESS,
    payload:{
        resFeature
    }
});

export const featureSettingsFailure = ({error}) => ({
    type: types.FETCH_FEATURE_SETTING_FAILURE,
    payload:{
        error:error.message
    }
});